import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { ArrowDownTrayIcon } from '@heroicons/react/24/outline';

export default function DownloadPage() {

    useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />

      <main className="flex-grow pt-16">
        
        {/* Main Section */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-8">
            
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
              
              {/* Left Column - Content */}
              <div>
                <h1 className="text-4xl font-bold text-gray-900 mb-4">
                  Ames Pro Desktop Software
                </h1>
                <p className="text-lg text-gray-600 mb-8 leading-tight">
                  The desktop software is required to export and upload your profiler data to Ames Connect. This latest version includes new cloud export functionality and enhanced data processing capabilities.
                </p>

               

                <div className="mt-8 pt-8 border-t border-gray-200">
                  <p className="text-sm text-gray-600">
                    Need help?{' '}
                    <a
                      href="https://www.amesengineering.com/support/supportRequest"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-red-600 hover:text-red-700 font-semibold"
                    >
                      Contact Support
                    </a>
                    {' or '}
                    <Link to="/" className="text-red-600 hover:text-red-700 font-semibold">
                      return to home
                    </Link>
                  </p>
                </div>
              </div>

              {/* Right Column - Download Card */}
              <div className="bg-white border border-gray-200 shadow-lg p-8">
                
                <h2 className="text-2xl font-bold text-gray-900 mb-6">
                  Download Ames Pro Desktop Software
                </h2>


                {/* Download Button */}
                <div className="space-y-4 mb-8">
                  <a
                    href="https://www.amesengineering.com/sales/salesRequest"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full inline-flex items-center justify-center bg-red-600 text-white px-6 py-4 font-semibold text-lg hover:bg-red-700 transition-colors"
                  >
                    <ArrowDownTrayIcon className="h-6 w-6 mr-2" />
                    Contact Sales to Download
                  </a>



                  <p className="text-sm text-gray-600 text-center">
                    Version 6.1.5 • November 2025
                  </p>
                </div>
 <div className="space-y-6">
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">
                      What's New
                    </h3>
                    <ul className="text-gray-600 space-y-1">
                      <li>• Cloud export tools for seamless data upload</li>
                      <li>• Full backwards compatibility with legacy data</li>
                    </ul>
                  </div>

                 
                </div>
              </div>

            </div>

          </div>
        </section>

      </main>

      <Footer />
    </div>
  );
}